export const environment = {
    production: false,
    clientKey: 'a7b2792f-5e10-4e92-a407-f3d17238b22a',

    typeDataApi: 'https://45typestudy-api.mosquitomade.com/api/TypeData',
    featureApi: 'https://45typestudy-api.mosquitomade.com/api/Features',
    typeFeatureApi: 'https://45typestudy-api.mosquitomade.com/api/TypeFeatures',
    userApi: 'https://45typestudy-api.mosquitomade.com/api/User',
};
